import { ITypedArrayObject } from '../../types/mappers/array';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { IReview } from '../../types/reviews';
import { EStatus } from '../../types/likes';

export enum EReviewsActionTypes {
  SetReviews = 'REVIEWS/SET_REVIEWS',
  SetAnswersVisibility = 'REVIEWS/SET_ANSWERS_VISIBILITY',
  AddAnswersToReview = 'REVIEWS/ADD_ANSWERS_TO_REVIEW',
  SetAnswersPage = 'REVIEWS/SET_ANSWERS_PAGE',
  SetReviewReaction = 'REVIEWS/SET_REVIEW_REACTION',
  SetReviewsPage = 'REVIEWS/SET_REVIEW_PAGE',
  OpenAllAnswers = 'REVIEWS/OPEN_ALL_ANSWERS',
  CloseAllAnswers = 'REVIEWS/CLOSE_ALL_ANSWERS',
  RemoveAnswerButton = 'REVIEWS/REMOVE_ANSWER_BUTTON',
}

export interface ISetReviewsPayload extends ITypedArrayObject<IReview, string> {
  hasMore: boolean;
  page: number;
}

export type TSetReviews = ITypedReduxAction<EReviewsActionTypes.SetReviews, ISetReviewsPayload>;
export type TSetReviewsPagination = ITypedReduxAction<EReviewsActionTypes.SetReviewsPage, ISetReviewsPayload>;

export interface ISetAnswersVisibilityPayload {
  reviewId: string;
  state: boolean;
}

export type TSetAnswersVisibility = ITypedReduxAction<
  EReviewsActionTypes.SetAnswersVisibility,
  ISetAnswersVisibilityPayload
>;

export interface IAddAnswersToReviewPayload {
  reviewId: string;
  answerIds: string[];
  hasMore: boolean;
  answersPage: number;
}

export type TAddAnswersToReview = ITypedReduxAction<EReviewsActionTypes.AddAnswersToReview, IAddAnswersToReviewPayload>;

export interface ISetAnswersPagePayload {
  reviewId: string;
  page: number;
}

export type TSetAnswersPage = ITypedReduxAction<EReviewsActionTypes.SetAnswersPage, ISetAnswersPagePayload>;

export type TSetReviewReactionPayload = {
  reviewId: string;
  type: EStatus;
};
export type TSetReviewReaction = ITypedReduxAction<EReviewsActionTypes.SetReviewReaction, TSetReviewReactionPayload>;

export type TOpenAllAnswers = ITypedReduxAction<EReviewsActionTypes.OpenAllAnswers>;
export type TCloseAllAnswers = ITypedReduxAction<EReviewsActionTypes.CloseAllAnswers>;
export type TRemoveAnswerButton = ITypedReduxAction<EReviewsActionTypes.RemoveAnswerButton, string>;

export type TReviewsActions =
  | TSetReviews
  | TSetAnswersVisibility
  | TAddAnswersToReview
  | TSetAnswersPage
  | TSetReviewReaction
  | TSetReviewsPagination
  | TOpenAllAnswers
  | TCloseAllAnswers
  | TRemoveAnswerButton;
